import React, {ReactNode} from 'react';
import DepositBonusTypeButton from './DepositBonusTypeButton';
import {inject, observer} from 'mobx-react';
import {DepositsStoreProps} from 'app/store/DepositsStore';
import I18n from 'app/i18n';
import Post from 'app/utils/Post';
import {toastError} from 'app/components/toasts/liteToast';
import {DEPOSIT_BONUS_TYPES} from 'app/utils/Consts';

interface Props extends DepositsStoreProps {
    cryptodeposit?: boolean
}

@inject('depositsStore')
@observer
export default class SelectBonusType extends React.Component<Props> {
    onClick = (selected_bonus: number): void => {
        if (this.props.cryptodeposit) {
            this.onClickCryptoDeposit(selected_bonus);
        } else {
            this.props.depositsStore.updateBonusType(selected_bonus);
        }
    };

    onClickCryptoDeposit = (bonus: number): void => {
        new Post({
            params: {bonus},
            url: '/deposits/crypto_deposit/change_bonus'
        })
            .execute()
            .then(data => data.json())
            .then(data => {
                if (data.success) {
                    this.props.depositsStore.updateBonusType(bonus);
                } else {
                    toastError(I18n.t('error_on_change_bonus'));
                }
            });
    };

    handleClickBetsBonusType = (): void => {
        this.onClick(DEPOSIT_BONUS_TYPES.BETS);
    };

    handleClickNoBonusType = (): void => {
        this.onClick(DEPOSIT_BONUS_TYPES.NO_BONUS);
    };

    render(): ReactNode {
        const {bonus_type} = this.props.depositsStore;

        return <div className="deposit-bonus">
            <span className="form__row-label">{I18n.t('promo_bonus_deposit_title')}</span>
            <div className="deposit-bonus__list">
                <DepositBonusTypeButton
                    bonusType="no_bonus"
                    active={bonus_type === DEPOSIT_BONUS_TYPES.NO_BONUS}
                    onClick={this.handleClickNoBonusType}
                    isNoBonusType
                />
                <DepositBonusTypeButton
                    bonusType="deposit"
                    active={bonus_type === DEPOSIT_BONUS_TYPES.BETS}
                    onClick={this.handleClickBetsBonusType}
                />
            </div>
        </div>;
    }
}
